<template>
  <div class="dialog_box" :class="`${ color || '' }`">
    <slot />
    <IconClose
      v-if="canClose"
      color="#fff" size="12"
      class="close"
      @click.native="clickClose"
    />
  </div>
</template>

<script>
import IconClose from '@/components/Icons/IconClose.vue'

export default {
  name: 'DialogBox',

  components: { IconClose },

  props: {
    color: {
      type: String,
      default: ''
    },
    canClose: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    clickClose () {
      this.$emit('clickClose')
    }
  },
}
</script>

<style lang="scss" scoped>
.dialog_box { position: relative; z-index: 1; min-width: 57px; min-height: 30px; background-color: #fff; border: 1px solid #D9D9D9; box-shadow: $box_shadow_2;
  &::before { position: absolute; top: -7px; right: 20px; z-index: -1; display: inline-block; width: 13px; height: 13px; content: ''; background-color: #fff; border-top: 1px solid #D9D9D9; border-left: 1px solid #D9D9D9; transform: rotate(45deg) translateX(0%); }
  &.blue { background-color: $theme_color;
    &::before { background-color: $theme_color; }
  }
  .close { position: absolute; top: 0; right: 0; transform: scale(0.7); }
}

</style>
